var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00208 15.7501C3.06283 15.7501 3.12358 15.7426 3.18358 15.7276L6.18358 14.9776C6.31558 14.9446 6.43633 14.8763 6.53233 14.7803L15.7521 5.56058C16.0356 5.27708 16.1916 4.90058 16.1916 4.50008C16.1916 4.09958 16.0356 3.72308 15.7521 3.43958L14.5626 2.25008C13.9956 1.68308 13.0086 1.68308 12.4416 2.25008L3.22183 11.4698C3.12583 11.5658 3.05758 11.6866 3.02458 11.8178L2.27458 14.8178C2.21008 15.0736 2.28583 15.3436 2.47183 15.5303C2.61358 15.6728 2.80558 15.7501 3.00208 15.7501ZM13.5021 3.31058L14.6916 4.50008L13.5021 5.68958L12.3126 4.50008L13.5021 3.31058ZM4.42933 12.3833L11.2521 5.56058L12.4416 6.75008L5.61808 13.5728L4.03258 13.9688L4.42933 12.3833Z",
    fill: "#139CFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil_icon.b93a06f1e8de01753eea20e8942fbced.svg";
export { ForwardRef as ReactComponent };